import { h } from 'preact';
import { configure } from '../../config';
import style from './style';
import { Text } from 'preact-i18n';
import { Icon } from '@cube/blocks';
import Logo from '@cube/logo-widget';

export function GdprWidget({ description, links, copyright, footerLinks }) {
	return (
		<div class={style.gdpr}>
			<Logo class={style.logo} theme="light" size="lg" link={false} />
			<div class={style.title}><Text id="gdprTitle" /></div>
			<div class={style.description}>{description}</div>
			<div class={style.links}>
				{links && links.map((link) =>
					(
						<div class={style.linkWrapper}>
							<a class={style.link} href={link.url}>
								<div class={style.linkContent}>
									<Icon name={link.icon} class={style.icon} />
									<div class={style.label}>{link.text}</div>
								</div>
							</a>
						</div>
					)
				)}
			</div>
			<div class={style.footer}>
				<span class={style.copyright}>
					{copyright}
				</span>
				{footerLinks && footerLinks.map((footerLink) =>
					(
						<a class={style.footerLink} href={footerLink.url}>
							{footerLink.text}
						</a>
					)
				)}
			</div>
		</div>);
}

export const Gdpr = (configure({
	description: 'privacyWidgetsConfig.gdpr.description',
	links: 'privacyWidgetsConfig.gdpr.links',
	copyright: 'privacyWidgetsConfig.gdpr.copyright',
	footerLinks: 'privacyWidgetsConfig.gdpr.footerLinks'
})((props) =>  (
	<GdprWidget {...props} />
)));
